import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

const ExampleContainer = ({ children, sxProp }: { children: React.ReactNode; sxProp?: SxProps<Theme> }) => {
   return (
      <Box
         sx={{
            width: 'fit-content',
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #00000010',
            ...sxProp,
         }}
      >
         {children}
      </Box>
   );
};

export default ExampleContainer;
